
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[...lander]",
      function () {
        return require("private-next-pages/shop/[...lander].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/[...lander]"])
      });
    }
  